import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles(theme => ({
  dialog: {
    width: '400px'
  },
  textMessage: {
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_400.main
  },
  dialogTitle: {
    color: theme.palette.blue_300.main
  }
}))
